import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../common.service';
@Component({
  selector: 'app-viewspeciesmanagement',
  templateUrl: './viewspeciesmanagement.component.html',
  styleUrls: ['./viewspeciesmanagement.component.css']
})
export class ViewspeciesmanagementComponent implements OnInit {
  returnUrl="/dashboard/speciesmanagement";
  agegroup="/dashboard/viewagegroup"
  getspeciesviewApi: string;
  getval:any;
  constructor(private router: Router,private commonService: CommonService) { }

 async ngOnInit(): Promise<void> {
    let speaciesId = sessionStorage.getItem('speciesId');
    this.getspeciesviewApi= "/species/"+ speaciesId;
    (await this.commonService.getApi(this.getspeciesviewApi)).subscribe(
      res => {
        console.log(res.data);
        $("#farmName").text(res.data.farm_name)
        $("#speciesviewName").text(res.data.name)
        $("#speciesviewId").text(res.data.speciesID)
        //$("#speciesviewFamName").text(res.data.family_name)
        //$('#farmName').text()
     this.getval=res.data.status;
        if (this.getval==1) 
{
  $("#speciesviewStatus").text("Active").addClass("green");
}
if (this.getval==0) {
 $("#speciesviewStatus").text("InActive").addClass("red");
}    
      
      })
    }
  speciesmanagement(){
    this.router.navigate([this.returnUrl]);
  }
  View_Age_Group(){
    this.router.navigate([this.agegroup]);
  }
  backnavigate(){
    this.router.navigate([this.returnUrl]);
  }
}
